/**
 * 사용할 색상을 관리한다.
 * 
 * 개발자 : T/F팀
 * 개발년월 : 2022.11 
*/

export class ColorData {
  static colors = undefined;

  static setColors(colors) {
    ColorData.colors = colors;
  }

  constructor() {
    this.index = 0;

    if (ColorData.colors === undefined) {
      ColorData.colors = [];

      let i = 1;
      while (true) {
        const element = document.querySelector(".color" + i);

        if (element) {
          const pseudoElementStyle = getComputedStyle(element);
          ColorData.colors.push(pseudoElementStyle.color);
          i++;
        } else {
          break;
        }
      }

    }
  }

  getNextColor(name) {
    const element = document.querySelector(name);
    if (element) {
      const pseudoElementStyle = window.getComputedStyle(element);
      return pseudoElementStyle.color;
    } else {
      return "yellow";
    }
  }

  makeColor() {
    function make() {
      let number = parseInt(Math.random() * 255);
      let hexStr = number.toString(16);
      if (hexStr.length === 1) {
        hexStr = "0" + hexStr;
      }
      return hexStr;
    }

    const ret = "#" + make() + make() + make();
    return ret;
  }
}




export class AlarmColor {
  static critical = '#fa323280';
  static major = '#c8646480';
  static minor = '#32963280';
  static warning = '#66B2FF';
  static normal = '#000000';

  static getColor(level) {
		if (AlarmLevel.CRITICAL == level) {
			return AlarmColor.critical;
		} else if (AlarmLevel.MAJOR == level) {
			return AlarmColor.major;
		} else if (AlarmLevel.MINOR == level) {
			return AlarmColor.minor;
		} else if (AlarmLevel.WARNING == level) {
			return AlarmColor.warning;
		} else {
			return AlarmColor.normal;
		}
	}
}



export class AlarmLevel {

	static CRITICAL = 1;
	static MAJOR = 2;
	static MINOR = 3;
	static WARNING = 4;
	static CLEAR = 9;

	static getName(level) {

		if (level == AlarmLevel.CRITICAL) {
			return "critical";
		} else if (level == AlarmLevel.MAJOR) {
			return "major";
		} else if (level == AlarmLevel.MINOR) {
			return "minor";
		} else if (level == AlarmLevel.WARNING) {
			return "warning";
		} else {
			return "normal";
		}
	}
}

